import React from 'react';
import { Box } from '@mui/material';

// A simple leaderboard-style bar: width proportional to `value` relative
// to `max` (the top row's value). Used for the Reports Usage tab's
// grouped app/domain list.
export default function RelativeBar({ value, max, color = '#6B7280' }) {
    const pct = max > 0 ? Math.max(4, Math.round((value / max) * 100)) : 0;
    return (
        <Box sx={{ width: '100%', height: 8, borderRadius: 999, bgcolor: 'rgba(255,255,255,0.06)', overflow: 'hidden' }}>
            <Box sx={{ width: `${pct}%`, height: '100%', bgcolor: color, borderRadius: 999 }} />
        </Box>
    );
}
